/**
 * Created by igor.kulishov on 8/30/2016.
 */
(function () {

    'use strict';

    angular
        .module('app.search')
        .directive('cacheLastSearchParams', ['$location', 'CacheSearchParams', function ($location, CacheSearchParams) {
            return {
                link: function(scope, element) {
                    element.bind('click', function() {
                        var location = $location.path();
                        var params = $location.search();
                        var searchCallbackUrl;
                        var scpritTags = document.getElementsByTagName('script');
                        for (var i = 0; i < scpritTags.length; i++) {
                            if (scpritTags[i].src.indexOf('callback') > 1) {

                                searchCallbackUrl = scpritTags[i].src.replace(/callback=OpenlaneSearchEngine.callback(\d)*/g,'');
                            }
                        }
                        CacheSearchParams.storeLastSearchParams(location, params, searchCallbackUrl);
                    });
                }
            }
        }]);

})();


// WEBPACK FOOTER //
// ./app/search/directives/cacheLastSearchParams.js